import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { LangKeys } from './store/mainSlice';

const resources = {
  he: {
    translation: {
      date: 'תאריך',
      loading: {
        text: 'טוען את המבצע שלך…',
      },
      splash: {
        topBar: 'הקישור שקיבלת אינו תקין — אבל הגעת למקום הנכון',
        eyebrow: 'פתרונות ניהול צי ובטיחות',
        titleLine1: 'כל המערכות.',
        titleLine2: 'מבצע אחד.',
        subtitle: 'קצין בטיחות, ניהול צי, דיווחי טכוגרף ועוד — כל פתרונות YIT תחת קורת גג אחת, עכשיו בתנאי הצטרפות מיוחדים.',
        ticker: 'קצין בטיחות ✦ RMS ✦ דיווח טכוגרף ✦ ניהול צי ✦ טפסים דיגיטליים ✦ מיקומי רכבים ✦ MyDay ✦',
        ctaWhatsapp: 'דברו איתנו ב-WhatsApp',
        ctaWebsite: 'לאתר YIT',
        whatsappMessage: 'אני מתעניין במוצר , צרו איתי קשר',
      },
      home: {
        phoneLabel: 'אמת/י את מספר הטלפון  כדי להמשיך לבאנדל קציני הבטיחות.',
        phonePlaceholder: '050-000-0000',
        phoneError: 'נא להזין מספר טלפון נייד תקין (לפחות 9 ספרות).',
        continue: 'המשך',
        note: 'קוד אימות חד-פעמי יישלח ב-SMS · ללא התחייבות',
      },
      otp: {
        title: 'הזנת קוד אימות',
        leadPrefix: 'שלחנו קוד בן 6 ספרות בהודעת SMS למספר',
        validity: 'הקוד תקף ל-{{count}} דקות',
        resend: 'שליחה חוזרת של הקוד',
        resendWait: 'שליחה חוזרת בעוד {{seconds}} שניות',
        submit: 'אימות והמשך',
        invalidCode: 'הקוד שהזנת שגוי. נותרו לך {{count}} מתוך {{total}} ניסיונות.',
      },
      companies: {
        title: 'עבור איזו חברה מיועדת הצעת המחיר?',
        subtitle: 'מספר הטלפון שלך משויך למספר חברות. בחר/י עבור איזו חברה מיועדת ההצעה.',
      },
      offer: {
        product: 'מוצר',
        period: 'תקופה',
        monthsDiscount: '{{count}} חודשים ב-{{percent}}% הנחה',
        premiumBonus: 'בונוס פרימיום - לאחר סיום תקופת ההטבה 2 משתמשים בעלות משתמש קבוע!',
        send: 'כן, אני מעוניין. שלחו לי הצעה',
        note: 'בלחיצה תיפתח פנייה במערכת והצעת המחיר תישלח אליך אוטומטית.',
        sentTitle: 'הצעת המחיר נשלחה בהצלחה',
        sentSubjectEmail: 'שלחנו את הצעת המחיר עבור חברת {{customer}} לכתובת המייל:',
        sentSubjectSms: 'שלחנו את הצעת המחיר עבור חברת {{customer}} למספר הטלפון:',
        ticketNumber: 'מספר פנייה: {{id}}',
        supportTitle: 'יש שאלה על ההצעה? אנחנו כאן',
        contactSalesPrefix: 'לכל שאלה ניתן ליצור קשר עם',
        salesTeam: 'מחלקת המכירות ב-WhatsApp',
        backToStart: 'חזרה למסך הפתיחה',
        whatsappMessage: 'היי אני מתעניין ב{{promoTitle}}, אשמח לקבל מידע נוסף',
      },
      errors: {
        formatInvalid: { title: 'הקישור לא אותר', msg: 'לא הצלחנו למצוא את המבצע המשויך לקישור זה. ייתכן שהקישור שגוי או הועתק באופן חלקי.' },
        packageWasNotFound: { title: 'הקישור לא אותר', msg: 'לא הצלחנו למצוא את המבצע המשויך לקישור זה. ייתכן שהקישור שגוי או הועתק באופן חלקי.' },
        packageIsNotActive: { title: 'המבצע אינו פעיל', msg: 'המבצע המבוקש הושהה זמנית ואינו זמין להפעלה כרגע. נשמח לעזור בטלפון או ב-WhatsApp.' },
        packageIsExpired: { title: 'תוקף המבצע הסתיים', msg: 'לצערנו חלון הזמן להפעלת מבצע זה הסתיים. נשמח להכין עבורך הצעה מעודכנת.' },
        contactWasNotFound: { title: 'המספר לא זוהה במערכת', msg: 'מספר הטלפון שהוזן אינו מופיע באנשי הקשר שלנו. ודא/י שהזנת את המספר הרשום אצלנו.', cta: 'הזנת מספר טלפון אחר' },
        contactIsNotAdmin: { title: 'אין הרשאה להמשיך', msg: 'איש הקשר שזוהה אינו מוגדר כמנהל מערכת, ולכן לא ניתן להפיק את ההצעה. פנה/י למנהל המערכת בארגון.' },
        smsServiceNotAvailiable: { title: 'שירות ה-SMS אינו זמין', msg: 'לא ניתן לשלוח כרגע קוד אימות ב-SMS. אנא נסה/י שוב מאוחר יותר או פנה/י לתמיכה.' },
        sendSmsFailed: { title: 'שליחת ה-SMS נכשלה', msg: 'אירעה שגיאה בשליחת קוד האימות. אנא נסה/י שוב.' },
        noTwoFaCodeWasSetToContact: { title: 'לא נמצא קוד אימות', msg: 'לא הוגדר קוד אימות עבור איש קשר זה. אנא פנה/י לתמיכה.' },
        twoFaCodeWasInvalid: { title: 'קוד האימות שגוי', msg: 'הקוד שהוזן אינו תקין. נסה/י שוב או בקש/י קוד חדש.' },
        ddosBlock: { title: 'בוצעו יותר מדי ניסיונות', msg: 'לצערנו בוצעו יותר מדי ניסיונות. אנא נסה שוב במועד מאוחר יותר.' },
        flowTokenNotValid: { title: 'נראה שעבר קצת זמן...', msg: 'מטעמי אבטחה תהליכים שאינם פעילים לאורך זמן מסתיימים אוטומטית. אין צורך לדאוג — פשוט התחילו מחדש.', cta: 'התחל/י מחדש' },
        maxSmsReached: { title: 'בוצעו יותר מדי ניסיונות', msg: 'הופעל מנגנון השהייה, אנא נסו שוב מאוחר יותר' },
        twoFaTooManyTries: { title: 'בוצעו יותר מדי ניסיונות', msg: 'הזנת קוד שגוי 5 פעמים. מטעמי אבטחה האימות נחסם זמנית. אנא נסה/י שוב במועד מאוחר יותר.' },
        general: { title: 'שגיאה כללית', msg: 'משהו השתבש. אנא נסה/י שוב, ואם הבעיה נמשכת פנה/י אלינו.' },
        supportTitle: 'עדיין תקוע/ה? אנחנו כאן',
        callSupportLabel: 'חיוג לתמיכה',
        whatsappSub: 'מענה ממכירות',
      },
      footer: {
        contactSupport: 'יצירת קשר ותמיכה',
        poweredBy: 'Powered by Y-IT',
      },
      a11y: {
        label: 'נגישות',
        menuTitle: 'תפריט נגישות',
        contrastSection: 'ניגודיות',
        contrastNormal: 'ניגודיות רגילה',
        contrastHigh: 'ניגודיות גבוהה',
        contrastBlackAndWhite: 'שחור - לבן',
        moreSettings: 'הגדרות נוספות',
        linkHighlight: 'הדגש קישורים',
        reset: 'ביטול נגישות',
      },
    },
  },
  en: {
    translation: {
      date: 'Date',
      loading: {
        text: 'Loading your offer…',
      },
      splash: {
        topBar: "The link you received isn't valid — but you've come to the right place",
        eyebrow: 'Fleet & safety management solutions',
        titleLine1: 'Every system.',
        titleLine2: 'One offer.',
        subtitle: 'Safety officer, fleet management, tachograph reporting and more — all YIT solutions under one roof, now on special joining terms.',
        ticker: 'Safety Officer ✦ RMS ✦ Tachograph Reporting ✦ Fleet Management ✦ Digital Forms ✦ Vehicle Locations ✦ MyDay ✦',
        ctaWhatsapp: 'Chat with us on WhatsApp',
        ctaWebsite: 'Visit YIT',
        whatsappMessage: "I'm interested in the product, please contact me",
      },
      home: {
        phoneLabel: 'Verify your phone number to continue to the safety officers bundle.',
        phonePlaceholder: '050-000-0000',
        phoneError: 'Please enter a valid mobile number (at least 9 digits).',
        continue: 'Continue',
        note: 'A one-time verification code will be sent by SMS · No commitment',
      },
      otp: {
        title: 'Enter verification code',
        leadPrefix: 'We sent a 6-digit code by SMS to',
        validity: 'The code is valid for {{count}} minutes',
        resend: 'Resend the code',
        resendWait: 'Resend available in {{seconds}}s',
        submit: 'Verify and continue',
        invalidCode: 'The code you entered is incorrect. You have {{count}} out of {{total}} tries left.',
      },
      companies: {
        title: 'Which company is this quote for?',
        subtitle: 'Your phone number is linked to several companies. Choose who the offer is for.',
      },
      offer: {
        product: 'Product',
        period: 'Period',
        monthsDiscount: '{{count}} months at {{percent}}% off',
        premiumBonus: 'Premium bonus - after the discount period ends, 2 users for the price of a single regular user!',
        send: "Yes, I'm interested. Send me the offer",
        note: 'This opens a ticket in the system and the quote is sent to you automatically.',
        sentTitle: 'The quote was sent successfully',
        sentSubjectEmail: 'We sent the quote for {{customer}} company to the email address:',
        sentSubjectSms: 'We sent the quote for {{customer}} company to the phone number:',
        ticketNumber: 'Ticket number: {{id}}',
        supportTitle: 'Have a question about the offer? We are here',
        contactSalesPrefix: 'For any question you can reach our',
        salesTeam: 'sales team on WhatsApp',
        backToStart: 'Back to start',
        whatsappMessage: "Hi, I'm interested in {{promoTitle}}, I'd love more information",
      },
      errors: {
        formatInvalid: { title: 'Link not found', msg: "We couldn't find the offer for this link. It may be incorrect or partially copied." },
        packageWasNotFound: { title: 'Link not found', msg: "We couldn't find the offer for this link. It may be incorrect or partially copied." },
        packageIsNotActive: { title: 'Offer inactive', msg: "The requested offer is temporarily paused and unavailable. We're happy to help by phone or WhatsApp." },
        packageIsExpired: { title: 'Offer expired', msg: "The window to activate this offer has closed. We'd be glad to prepare an updated offer." },
        contactWasNotFound: { title: 'Number not recognized', msg: "The entered number isn't in our contacts. Make sure it's the number registered with us.", cta: 'Enter a different phone number' },
        contactIsNotAdmin: { title: 'No permission to continue', msg: "The identified contact isn't a system admin, so the offer can't be generated. Please contact your organization's admin." },
        smsServiceNotAvailiable: { title: 'SMS service unavailable', msg: "We can't send a verification code by SMS right now. Please try again later or contact support." },
        sendSmsFailed: { title: 'SMS sending failed', msg: 'An error occurred while sending the verification code. Please try again.' },
        noTwoFaCodeWasSetToContact: { title: 'No verification code found', msg: 'No verification code is set for this contact. Please contact support.' },
        twoFaCodeWasInvalid: { title: 'Invalid code', msg: 'The code you entered is incorrect. Try again or request a new code.' },
        ddosBlock: { title: 'Too many attempts', msg: 'Too many attempts. Please try again later.' },
        flowTokenNotValid: { title: 'Looks like some time has passed...', msg: 'For security reasons, inactive sessions end automatically. No worries — just start again.', cta: 'Start again' },
        maxSmsReached: { title: 'Too many attempts', msg: 'A cooldown has been triggered, please try again later.' },
        twoFaTooManyTries: { title: 'Too many attempts', msg: 'You entered an incorrect code 5 times. For security reasons, verification has been temporarily blocked. Please try again later.' },
        general: { title: 'General error', msg: 'Something went wrong. Please try again, and contact us if the issue persists.' },
        supportTitle: 'Still stuck? We are here',
        callSupportLabel: 'Call support',
        whatsappSub: 'Sales team reply',
      },
      footer: {
        contactSupport: 'Contact & support',
        poweredBy: 'Powered by Y-IT',
      },
      a11y: {
        label: 'Accessibility',
        menuTitle: 'Accessibility menu',
        contrastSection: 'Contrast',
        contrastNormal: 'Normal Contrast',
        contrastHigh: 'High contrast',
        contrastBlackAndWhite: 'Black & White',
        moreSettings: 'More settings',
        linkHighlight: 'Highlight links',
        reset: 'Cancel accessibility',
      },
    },
  },
  ar: {
    translation: {
      date: 'التاريخ',
      loading: {
        text: 'جارٍ تحميل العرض الخاص بك…',
      },
      splash: {
        topBar: 'الرابط الذي استلمته غير صالح — لكنك وصلت إلى المكان الصحيح',
        eyebrow: 'حلول إدارة الأسطول والسلامة',
        titleLine1: 'كل الأنظمة.',
        titleLine2: 'عرض واحد.',
        subtitle: 'ضابط سلامة، إدارة أسطول، تقارير تاكوغراف والمزيد — جميع حلول YIT تحت سقف واحد، الآن بشروط انضمام خاصة.',
        ticker: 'ضابط سلامة ✦ RMS ✦ تقرير تاكوغراف ✦ إدارة أسطول ✦ نماذج رقمية ✦ مواقع المركبات ✦ MyDay ✦',
        ctaWhatsapp: 'تواصل معنا عبر واتساب',
        ctaWebsite: 'موقع YIT',
        whatsappMessage: 'أنا مهتم بالمنتج، يرجى التواصل معي',
      },
      home: {
        phoneLabel: 'يرجى التحقق من رقم هاتفك للمتابعة إلى باقة ضباط السلامة.',
        phonePlaceholder: '050-000-0000',
        phoneError: 'يرجى إدخال رقم هاتف محمول صحيح (9 أرقام على الأقل).',
        continue: 'متابعة',
        note: 'سيتم إرسال رمز تحقق لمرة واحدة عبر SMS · دون التزام',
      },
      otp: {
        title: 'إدخال رمز التحقق',
        leadPrefix: 'أرسلنا رمزاً من 6 أرقام عبر SMS إلى الرقم',
        validity: 'الرمز صالح لمدة {{count}} دقائق',
        resend: 'إعادة إرسال الرمز',
        resendWait: 'إعادة الإرسال بعد {{seconds}} ثانية',
        submit: 'تحقّق ومتابعة',
        invalidCode: 'الرمز الذي أدخلته غير صحيح. تبقّت لك {{count}} من أصل {{total}} محاولات.',
      },
      companies: {
        title: 'لأي شركة موجّه عرض السعر؟',
        subtitle: 'رقم هاتفك مرتبط بعدة شركات. اختر لمن هذا العرض.',
      },
      offer: {
        product: 'المنتج',
        period: 'المدة',
        monthsDiscount: '{{count}} أشهر بخصم {{percent}}%',
        premiumBonus: 'مكافأة بريميوم - بعد انتهاء فترة الخصم، مستخدمان بتكلفة مستخدم واحد ثابت!',
        send: 'نعم، أنا مهتم. أرسلوا لي العرض',
        note: 'بالنقر يُفتح طلب في النظام ويُرسل العرض إليك تلقائياً.',
        sentTitle: 'تم إرسال عرض السعر بنجاح',
        sentSubjectEmail: 'أرسلنا عرض السعر لشركة {{customer}} إلى عنوان البريد الإلكتروني:',
        sentSubjectSms: 'أرسلنا عرض السعر لشركة {{customer}} إلى رقم الهاتف:',
        ticketNumber: 'رقم الطلب: {{id}}',
        supportTitle: 'لديك سؤال حول العرض؟ نحن هنا',
        contactSalesPrefix: 'لأي سؤال يمكنك التواصل مع',
        salesTeam: 'فريق المبيعات عبر WhatsApp',
        backToStart: 'العودة إلى البداية',
        whatsappMessage: 'مرحباً، أنا مهتم بـ {{promoTitle}}، أود الحصول على مزيد من المعلومات',
      },
      errors: {
        formatInvalid: { title: 'الرابط غير موجود', msg: 'لم نتمكن من العثور على العرض المرتبط بهذا الرابط. قد يكون خاطئاً أو منسوخاً جزئياً.' },
        packageWasNotFound: { title: 'الرابط غير موجود', msg: 'لم نتمكن من العثور على العرض المرتبط بهذا الرابط. قد يكون خاطئاً أو منسوخاً جزئياً.' },
        packageIsNotActive: { title: 'العرض غير مفعّل', msg: 'العرض المطلوب متوقف مؤقتاً وغير متاح حالياً. يسعدنا المساعدة عبر الهاتف أو واتساب.' },
        packageIsExpired: { title: 'انتهت صلاحية العرض', msg: 'انتهت نافذة تفعيل هذا العرض. يسعدنا إعداد عرض محدّث لك.' },
        contactWasNotFound: { title: 'الرقم غير معروف في النظام', msg: 'الرقم المُدخل غير موجود في جهات اتصالنا. تأكد أنه الرقم المسجّل لدينا.', cta: 'إدخال رقم هاتف آخر' },
        contactIsNotAdmin: { title: 'لا صلاحية للمتابعة', msg: 'جهة الاتصال المُعرّفة ليست مسؤول نظام، لذلك لا يمكن إصدار العرض. يرجى التواصل مع مسؤول النظام في مؤسستك.' },
        smsServiceNotAvailiable: { title: 'خدمة الرسائل القصيرة غير متاحة', msg: 'لا يمكننا حالياً إرسال رمز التحقق عبر الرسائل القصيرة. يرجى المحاولة لاحقاً أو التواصل مع الدعم.' },
        sendSmsFailed: { title: 'فشل إرسال الرسالة القصيرة', msg: 'حدث خطأ أثناء إرسال رمز التحقق. يرجى المحاولة مرة أخرى.' },
        noTwoFaCodeWasSetToContact: { title: 'لم يتم العثور على رمز تحقق', msg: 'لا يوجد رمز تحقق مُعرّف لجهة الاتصال هذه. يرجى التواصل مع الدعم.' },
        twoFaCodeWasInvalid: { title: 'رمز التحقق غير صحيح', msg: 'الرمز المُدخل غير صحيح. حاول مرة أخرى أو اطلب رمزاً جديداً.' },
        ddosBlock: { title: 'محاولات كثيرة جداً', msg: 'تم إجراء محاولات كثيرة جداً. يرجى المحاولة لاحقاً.' },
        flowTokenNotValid: { title: 'يبدو أن بعض الوقت قد مر...', msg: 'لأسباب أمنية، تنتهي الجلسات غير النشطة تلقائيًا. لا داعي للقلق — ابدأ/ي من جديد فقط.', cta: 'ابدأ/ي من جديد' },
        maxSmsReached: { title: 'محاولات كثيرة جداً', msg: 'تم تفعيل آلية تأخير، يرجى المحاولة مرة أخرى لاحقاً.' },
        twoFaTooManyTries: { title: 'محاولات كثيرة جداً', msg: 'لقد أدخلت رمزاً غير صحيح 5 مرات. لأسباب أمنية، تم حظر التحقق مؤقتاً. يرجى المحاولة مرة أخرى لاحقاً.' },
        general: { title: 'خطأ عام', msg: 'حدث خطأ ما. يرجى المحاولة مرة أخرى، والتواصل معنا إذا استمرت المشكلة.' },
        supportTitle: 'ما زلت بحاجة إلى مساعدة؟ نحن هنا',
        callSupportLabel: 'اتصل بالدعم',
        whatsappSub: 'ردّ فريق المبيعات',
      },
      footer: {
        contactSupport: 'اتصال ودعم',
        poweredBy: 'Powered by Y-IT',
      },
      a11y: {
        label: 'إمكانية الوصول',
        menuTitle: 'قائمة بإمكانية الوصول',
        contrastSection: 'تباين',
        contrastNormal: 'تباين اعتيادي',
        contrastHigh: 'تباين عالي',
        contrastBlackAndWhite: 'اسود- ابيض',
        moreSettings: 'إعدادات إضافية',
        linkHighlight: 'قم بتأكيد الروابط',
        reset: 'إلغاء إمكانية الوصول',
      },
    },
  },
  ru: {
    translation: {
      date: 'Дата',
      loading: {
        text: 'Загружаем ваше предложение…',
      },
      splash: {
        topBar: 'Полученная вами ссылка недействительна — но вы попали куда нужно',
        eyebrow: 'Решения для управления автопарком и безопасности',
        titleLine1: 'Все системы.',
        titleLine2: 'Одно предложение.',
        subtitle: 'Инспектор по безопасности, управление автопарком, отчёты тахографа и многое другое — все решения YIT под одной крышей, теперь на специальных условиях подключения.',
        ticker: 'Инспектор по безопасности ✦ RMS ✦ Отчёт тахографа ✦ Управление автопарком ✦ Цифровые формы ✦ Местоположение техники ✦ MyDay ✦',
        ctaWhatsapp: 'Напишите нам в WhatsApp',
        ctaWebsite: 'Сайт YIT',
        whatsappMessage: 'Меня интересует продукт, свяжитесь со мной',
      },
      home: {
        phoneLabel: 'Подтвердите номер телефона, чтобы продолжить к пакету для специалистов по безопасности.',
        phonePlaceholder: '050-000-0000',
        phoneError: 'Введите корректный номер (не менее 9 цифр).',
        continue: 'Продолжить',
        note: 'Одноразовый код подтверждения будет отправлен по SMS · Без обязательств',
      },
      otp: {
        title: 'Введите код подтверждения',
        leadPrefix: 'Мы отправили 6-значный код по SMS на номер',
        validity: 'Код действителен {{count}} минут',
        resend: 'Отправить код повторно',
        resendWait: 'Повторная отправка через {{seconds}} с',
        submit: 'Подтвердить и продолжить',
        invalidCode: 'Введённый код неверен. У вас осталось {{count}} из {{total}} попыток.',
      },
      companies: {
        title: 'Для какой компании это предложение?',
        subtitle: 'Ваш номер телефона связан с несколькими компаниями. Выберите, для кого предложение.',
      },
      offer: {
        product: 'Продукт',
        period: 'Период',
        monthsDiscount: '{{count}} мес. со скидкой {{percent}}%',
        premiumBonus: 'Премиум-бонус - по окончании льготного периода 2 пользователя по цене одного обычного пользователя!',
        send: 'Да, интересно. Пришлите предложение',
        note: 'При нажатии создаётся заявка, и предложение отправляется автоматически.',
        sentTitle: 'Предложение успешно отправлено',
        sentSubjectEmail: 'Мы отправили предложение для компании {{customer}} на email:',
        sentSubjectSms: 'Мы отправили предложение для компании {{customer}} на номер телефона:',
        ticketNumber: 'Номер заявки: {{id}}',
        supportTitle: 'Есть вопрос по предложению? Мы здесь',
        contactSalesPrefix: 'По любым вопросам свяжитесь с',
        salesTeam: 'отделом продаж в WhatsApp',
        backToStart: 'Вернуться к началу',
        whatsappMessage: 'Здравствуйте, меня интересует {{promoTitle}}, хотел(а) бы узнать больше',
      },
      errors: {
        formatInvalid: { title: 'Ссылка не найдена', msg: 'Не удалось найти предложение по этой ссылке. Возможно, она неверна или скопирована частично.' },
        packageWasNotFound: { title: 'Ссылка не найдена', msg: 'Не удалось найти предложение по этой ссылке. Возможно, она неверна или скопирована частично.' },
        packageIsNotActive: { title: 'Предложение неактивно', msg: 'Запрошенное предложение временно приостановлено и недоступно. Поможем по телефону или в WhatsApp.' },
        packageIsExpired: { title: 'Срок предложения истёк', msg: 'Срок активации этого предложения истёк. Будем рады подготовить новое.' },
        contactWasNotFound: { title: 'Номер не распознан', msg: 'Введённый номер отсутствует в наших контактах. Убедитесь, что это зарегистрированный номер.', cta: 'Ввести другой номер телефона' },
        contactIsNotAdmin: { title: 'Нет прав для продолжения', msg: 'Определённый контакт не является администратором, поэтому предложение нельзя создать. Обратитесь к администратору организации.' },
        smsServiceNotAvailiable: { title: 'Служба SMS недоступна', msg: 'Сейчас невозможно отправить код подтверждения по SMS. Попробуйте позже или обратитесь в поддержку.' },
        sendSmsFailed: { title: 'Не удалось отправить SMS', msg: 'Произошла ошибка при отправке кода подтверждения. Пожалуйста, попробуйте снова.' },
        noTwoFaCodeWasSetToContact: { title: 'Код подтверждения не найден', msg: 'Для этого контакта не задан код подтверждения. Пожалуйста, обратитесь в поддержку.' },
        twoFaCodeWasInvalid: { title: 'Неверный код', msg: 'Введённый код неверен. Попробуйте снова или запросите новый код.' },
        ddosBlock: { title: 'Слишком много попыток', msg: 'Слишком много попыток. Пожалуйста, попробуйте позже.' },
        flowTokenNotValid: { title: 'Похоже, прошло немного времени...', msg: 'В целях безопасности неактивные сессии завершаются автоматически. Не волнуйтесь — просто начните заново.', cta: 'Начать заново' },
        maxSmsReached: { title: 'Слишком много попыток', msg: 'Включён механизм задержки, пожалуйста, попробуйте позже.' },
        twoFaTooManyTries: { title: 'Слишком много попыток', msg: 'Вы ввели неверный код 5 раз. В целях безопасности проверка временно заблокирована. Пожалуйста, попробуйте позже.' },
        general: { title: 'Общая ошибка', msg: 'Что-то пошло не так. Попробуйте снова, а если проблема повторяется — свяжитесь с нами.' },
        supportTitle: 'Нужна помощь? Мы здесь',
        callSupportLabel: 'Позвонить в поддержку',
        whatsappSub: 'Ответ отдела продаж',
      },
      footer: {
        contactSupport: 'Контакты и поддержка',
        poweredBy: 'Powered by Y-IT',
      },
      a11y: {
        label: 'Специальные возможности',
        menuTitle: 'Меню специальных возможностей',
        contrastSection: 'Контрастность',
        contrastNormal: 'Нормальная контрастность',
        contrastHigh: 'Высокая контрастность',
        contrastBlackAndWhite: 'Черно-белый режим',
        moreSettings: 'Больше настроек',
        linkHighlight: 'Выделить ссылки',
        reset: 'Отменить специальные возможности',
      },
    },
  },
};
export const i18nLanguages = Object.keys(resources) as LangKeys[];

export const langItems: { code: LangKeys; name: string }[] = [
  { code: 'he', name: 'עברית' },
  { code: 'en', name: 'English' },
  { code: 'ar', name: 'العربية' },
  { code: 'ru', name: 'Русский' },
];

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'he',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
